import { useEffect, useState } from 'react';
import { AudioOut } from '../../../../components/WordButton';
import { useExercise } from '../../../../context/exercise';
import { OptionsWrapper, OptionWrapper } from './style';

const DisplayMultipleWords = ({
  wordsArray,
  setEnableNext,
  needsRowFormat,
}) => {
  const { setSubProgress } = useExercise();
  const formattedWordsArray = wordsArray.map((el, idx) => ({ ...el, id: idx }));

  const [itemsPlayed, setItemsPlayed] = useState({});

  const handleClick = (el) => {
    if (!el.isPlayed) {
      el.isPlayed = true;
      setItemsPlayed((itemsPlayed) => ({ ...itemsPlayed, [el.id]: true }));
    }

    return;
  };
  const _itemsPlayed = Object.keys(itemsPlayed);

  useEffect(() => {
    const allSubStepsPlayed = _itemsPlayed.length === wordsArray.length;
    if (allSubStepsPlayed) {
      setEnableNext(true);
    }
    setSubProgress(_itemsPlayed.length / wordsArray.length);
  }, [_itemsPlayed.length, setEnableNext, setSubProgress, wordsArray.length]);

  return (
    <OptionsWrapper needsRowFormat={needsRowFormat}>
      {formattedWordsArray.map((el, i) => (
        <OptionWrapper
          key={`col-${el?.option}-${i}`}
          needsRowFormat={needsRowFormat}
        >
          <AudioOut
            audioUrl={el?.audioUrl}
            handleClick={() => handleClick(el)}
            text={el?.option}
            mb={2}
            key={`div-${el?.option}-${i}`}
            needsRowFormat={needsRowFormat}
            fallbackText={el?.option}
          />
        </OptionWrapper>
      ))}
    </OptionsWrapper>
  );
};

export default DisplayMultipleWords;
